import {CookiesProvider} from 'react-cookie'
import PropTypes from 'prop-types'
import {Flex} from '@chakra-ui/react'

import {SupplierRewardsProgramLearnMoreModalProvider} from '../../contexts/supplierRewardsProgramLearnMoreModal'
import SideNavV2Layout from '../SideNavV2Layout'
import {NAV_CARD_INSET} from '../../components/SideNavV2/NavPanel'
import {Announcements} from '../../components'

const SupplierLayout = ({children, state}) => (
  <CookiesProvider>
    <SupplierRewardsProgramLearnMoreModalProvider>
      <SideNavV2Layout state={state}>
        <Announcements />
        {children}
      </SideNavV2Layout>
    </SupplierRewardsProgramLearnMoreModalProvider>
  </CookiesProvider>
)

SupplierLayout.propTypes = {
  children: PropTypes.node.isRequired,
  state: PropTypes.string.isRequired,
}

export const NewSupplierLayout = ({children, state, variant}) => (
  <SupplierLayout state={state} variant={variant}>
    <Flex
      minH="100vh"
      direction="column"
      bgColor={
        {primary: 'mld.neutral.0', secondary: 'mld.neutral.200'}[variant]
      }
      px="md"
      pt={NAV_CARD_INSET}
      pb="md"
      gap="sm"
    >
      {children}
    </Flex>
  </SupplierLayout>
)

NewSupplierLayout.defaultProps = {
  variant: 'primary',
}

NewSupplierLayout.propTypes = {
  children: PropTypes.node.isRequired,
  state: PropTypes.string.isRequired,
  variant: PropTypes.string,
}

export default SupplierLayout
